/**
 * One interval for the whole app.
 *
 * Re-renders every 250ms while any timeline is live and stops when none are.
 * It returns "now" so a component reads the clock the engine reads, and never
 * keeps its own copy of progress.
 */

import { useEffect, useReducer } from 'react';
import { anyLive } from '../mock/simulate';
import { useDemoStore } from '../mock/store';

export function useTicker(intervalMs = 250): number {
  const timelines = useDemoStore((s) => s.timelines);
  const [, bump] = useReducer((n: number) => n + 1, 0);
  const live = anyLive(timelines, Date.now());

  useEffect(() => {
    if (!live) return;
    const id = window.setInterval(bump, intervalMs);
    return () => window.clearInterval(id);
  }, [live, intervalMs]);

  return Date.now();
}
